import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Form, Input, Select } from 'antd';

import { GET, queryFilterByItem, errorCatch } from 'fennec-ui'
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

const { Option } = Select;

function SelectGroup({ value, onChange, options }) {
    return (
        <Input.Group compact style={{ display: "flex" }}>
            <Select
                onChange={onChange}
                value={value}

                style={{ flex: "auto" }}
                allowClear
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => {
                    return option?.label?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }}
                filterSort={(optionA, optionB) =>
                    optionA?.label?.toLowerCase().localeCompare(optionB?.label?.toLowerCase())
                }
            >
                {options}
            </Select>
            {/* <Button style={{ padding: "4px 8px" }} onClick={() => { }}>
                <EllipsisOutlined style={{ paddingTop: "7px", fontSize: '16px' }} />
            </Button> */}
            {/* <Button style={{ padding: "4px 8px" }} onClick={()=>{}}>
                        <PlusOutlined style={{ paddingTop: "3px", fontSize: '16px' }} />
                    </Button> */}
        </Input.Group>
    );
}

export default function NovieKomissiiVYacheikakh(props) {
    const { auth, object, form, sourceKey, queryFilterContext, soruceID, parentObject } = props;
    const dispatch = useDispatch();
    const [yacheikaVUsluge, setYacheikaVUsluge] = useState([])
    useEffect(() => {
        form.resetFields();

        let postfix = "";
        if (sourceKey === "admin") {
            postfix = `/${soruceID}`
        }

        GET(auth, "/api/yacheikiuslugi/list/" + sourceKey + postfix + "?detail=model&w-notActive=false&" + (soruceID ? `w-eqornu-meropriyatie.ID=${soruceID}&` : "") + ((queryFilterContext) ? queryFilterByItem(queryFilterContext) : ""),
            ({ data }) => {
                setYacheikaVUsluge(data)
            },
            (err) => errorCatch(err));
    }, []);
    const yacheikaVUslugeOptions = yacheikaVUsluge.map((i) => {
        let desc = "";
        if (i?.organizatorFederatsiyaID) {
            desc = "Федерация"
        } else if (i?.organizatorRegionalnoeOtdelenieID) {
            desc = "" + i?.organizatorRegionalnoeOtdelenie?.nazvanie
        } else if (i?.organizatorShkolaID) {
            desc = "" + i?.organizatorShkola?.nazvanieShkoliTantsev
        } else if (i?.organizatorMeropriyatiyaID) {
            desc = "" + i?.organizatorMeropriyatiya?.nazvanie
        }

        if (i?.meropriyatie) {
            desc += ", " + `${i?.meropriyatie?.nazvanieMeropriyatiya} - ${dayjs(i?.meropriyatie?.nachaloSorevnovaniya).format("DD.MM.YYYY")} ${(i?.meropriyatie?.mestoProvedeniya) ? "(" + i?.meropriyatie?.mestoProvedeniya?.name + ")" : ""}`
        }
        return (<Option key={i.ID} value={i.ID} label={i.nazvanie}>
            <div>{i.nazvanie}</div>
            {desc && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>{desc}</div>}
        </Option>)
    });
    const display = (object) => {
        let res = object.nomerAkkaunta + " ";

        if (object.akkauntiFedAkkaunt && object.akkauntiFedAkkaunt.length > 0) {
            res += "Счет федерации социальных танцев";
        } else if (object.akkauntiPolzovateleiAkkaunt && object.akkauntiPolzovateleiAkkaunt.length > 0) {
            res += object.akkauntiPolzovateleiAkkaunt.map(e => {
                return e.polzovatel.lastname + " " + e.polzovatel.firstname;
            }).join(" ");
        } else if (object.akkauntiRegionalnikhOtdeleniiAkkaunt && object.akkauntiRegionalnikhOtdeleniiAkkaunt.length > 0) {
            res += object.akkauntiRegionalnikhOtdeleniiAkkaunt.map(e => {
                return e.regionalnoOtdelenie.nazvanie;
            }).join(" ");
        } else if (object.akkauntiOrganizatorovAkkaunt && object.akkauntiOrganizatorovAkkaunt.length > 0) {
            res += "Организатор: " + object.akkauntiOrganizatorovAkkaunt.map(e => {
                return e.organizator.nazvanie;
            }).join(" ");
        } else if (object.akkauntiShkolAkkaunt && object.akkauntiShkolAkkaunt.length > 0) {
            res += "Школа: " + object.akkauntiShkolAkkaunt.map(e => {
                return e.shkola.nazvanieShkoliTantsev;
            }).join(" ");
        }
        return res;
    }
    return (
        <>
            <Form
                form={form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    ...object
                }}
            >
                <div style={{ paddingBottom: "10px" }}>
                    {parentObject.sutKomissii &&
                        <div style={{ display: "flex", gap: "5px" }}>
                            {/* {JSX(()=>{console.log(object)})} */}
                            <div>
                                <span style={{ fontWeight: "300" }}>Комиссия: </span>
                            </div>
                            <div>
                                <div>
                                    <span>{parentObject?.sutKomissii}</span>
                                </div>
                                {parentObject?.meropriyatie && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                    <span>{parentObject?.meropriyatie?.nazvanieMeropriyatiya}</span> - {dayjs(parentObject?.meropriyatie?.nachaloSorevnovaniya).format("DD.MM.YYYY")} {(parentObject?.meropriyatie?.mestoProvedeniya) ? "(" + parentObject?.meropriyatie?.mestoProvedeniya?.name + ")" : ""}
                                </div>}
                                {parentObject?.organizatorFederatsiyaID && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                    <span>Федерация</span>
                                </div>}
                                {parentObject?.organizatorRegionalnoeOtdelenieID && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                    <span>{parentObject?.organizatorRegionalnoeOtdelenie?.nazvanie}</span>
                                </div>}
                                {parentObject?.organizatorShkolaID && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                    <span>{parentObject?.organizatorShkola?.nazvanieShkoliTantsev}</span>
                                </div>}
                                {parentObject?.organizatorMeropriyatiyaID && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                    <span>{parentObject?.organizatorMeropriyatiya?.nazvanie}</span>
                                </div>}
                            </div>
                        </div>
                    }
                    {(parentObject && parentObject.akkaunt) &&
                        <div>
                            <span style={{ fontWeight: "300" }}>Счет: </span><span>{display(parentObject.akkaunt)}</span>
                        </div>
                    }
                    {(parentObject && parentObject.kakVichislitAkkaunt) &&
                        <div>
                            <span style={{ fontWeight: "300" }}>Определение счета: </span><span>{parentObject.kakVichislitAkkaunt.opisanie}</span>
                        </div>
                    }
                </div>
                <Form.Item label="Услуга"
                    name="yacheikaVUslugeID"
                    rules={[{ required: false, message: 'Пожалуйста, укажите услугу!' }]}
                >
                    <SelectGroup
                        options={yacheikaVUslugeOptions}
                    />
                </Form.Item>
            </Form>
        </>
    );
}
